interface BitrixWindow extends Window {
  BX?: {
    bitrix_sessid?: () => string;
  };
  bitrix_sessid?: string;
}

const readBitrixSessidFromDom = (): string | null => {
  const inputValue = document.querySelector<HTMLInputElement>('input[name="sessid"]')?.value?.trim();
  if (inputValue) {
    return inputValue;
  }

  const metaValue = document.querySelector<HTMLMetaElement>('meta[name="bitrix_sessid"]')?.content?.trim();
  if (metaValue) {
    return metaValue;
  }

  return null;
};

export const getBitrixSessid = (): string | null => {
  const w = window as BitrixWindow;
  const bxSessid = w.BX?.bitrix_sessid?.()?.trim();
  if (bxSessid) {
    return bxSessid;
  }

  const globalSessid = w.bitrix_sessid?.trim();
  if (globalSessid) {
    return globalSessid;
  }

  return readBitrixSessidFromDom();
};
